import React, { useEffect, useRef } from 'react';

const MapWithRoute = () => {
  const mapRef = useRef(null);

  const start = { lat: 28.638555, lng: 76.965502 };
  const end = { lat: 28.539669, lng: 77.051907 };

  useEffect(() => {
    // Wait until Ola Maps is loaded
    const interval = setInterval(() => {
      if (window.ola) {
        clearInterval(interval);
        initMap();
      }
    }, 100);

    const initMap = async () => {
      const map = new window.ola.Map(mapRef.current, {
        center: start,
        zoom: 12,
      });

      // Fetch the route from Ola Directions API
      const response = await fetch('https://api.olamaps.io/routing/v1/directions?origin=28.638555,76.965502&destination=28.539669,77.051907', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "ApiKey OCz4wTePiyBkJkEXGI6fLncsaw65XtEmblmHWFSa"
        },
       
         body: JSON.stringify({})
       
      });

      const data = await response.json();

      const encodedPolyline = data.routes?.[0]?.overview_polyline;
      if (!encodedPolyline) return;

      // Decode and draw the polyline
      const routePath = window.ola.geometry.decodePath(encodedPolyline);

      const routeLine = new window.ola.Polyline({
        path: routePath,
        strokeColor: '#FF5733',
        strokeOpacity: 1.0,
        strokeWeight: 4,
      });

      routeLine.setMap(map);

      // Add origin and destination markers
      new window.ola.Marker({ position: start, map, title: 'Start' });
      new window.ola.Marker({ position: end, map, title: 'End' });
    };
  }, []);

  return (
    <div style={{ height: '600px', width: '100%' }}>
      <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};

export default MapWithRoute;
